import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service'
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  @Input() IsSidebarOpen: boolean;

  dynamicMenu: any = []
  subscription: any;
  authorisedMenus: any = [];

  constructor(private dataService: DataService, private commonService: CommonService, private router: Router, private activeRoute: ActivatedRoute, private encryptDecryptservice: EncryptDecryptService,private memorystore: MemoryStorageService) {
    this.subscription = EmmiterService.get("userInfo").subscribe(res => {

      this.dynamicMenu = [];
      this.authorisedMenus = [];
      this.commonService.reportList = [];
      this.getMenuItem();
    });
  }

  ngOnInit(): void { }

  async getMenuItem() {
    this.dynamicMenu = [];
    this.authorisedMenus = [];
    this.commonService.reportList = [];

    let params = new HttpParams;
    params = params.append("project_id", this.commonService.selectedProject);
    params = params.append("subgroup_id", (this.commonService.selectedSubgroup == "null") ? 0 : this.commonService.selectedSubgroup);
    params = params.append("role_id", this.commonService.selectedRole);
    let bodydata = {
      role_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedRole),
      subgroup_id: this.encryptDecryptservice.encryptUsingAES256((this.commonService.selectedSubgroup == "null") ? 0 : this.commonService.selectedSubgroup),
      project_id: this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject)
    };
    // let bodydata = {
    //   role_id:  this.commonService.selectedRole,
    //   subgroup_id: (this.commonService.selectedSubgroup == "null") ? 0 : this.commonService.selectedSubgroup,
    //   project_id:this.commonService.selectedProject
    //  };
    //changed getData to postData
    await this.dataService.postData('menu', bodydata).subscribe(res => {
      if (res) {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          let lstSubMenu = [];
          res.data.forEach(menu => {
            // if ((this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 1 && menu.menu_route != '/dashboard') || (this.commonService.getUserInfoFromLocalStorage('isManagerialRole') == 0 && menu.menu_route != '/work-item')) { 
            if ((this.memorystore.getItem('isManagerialRole') == 1 && menu.menu_route != '/dashboard') || (this.memorystore.getItem('isManagerialRole') == 0 && menu.menu_route != '/work-item')) {
              //let lstSubMenu = [];
              lstSubMenu = [];
              menu.sub_menus = JSON.parse(menu.sub_menus);
              if (menu.sub_menus.length > 0) {
                menu.sub_menus.forEach(submenu => {
                  if (menu.menu_name == 'Reports' || menu.menu_name == 'Offline Report' || menu.menu_name == 'Standard Report' || menu.menu_name == 'Custom Report') {
                    if (submenu.menu_name == 'IBOS-360')
                      lstSubMenu.push({ name: submenu.menu_name, icon: submenu.menu_icon, routerLink: [submenu.menu_route] });
                    else
                      lstSubMenu.push({ name: submenu.menu_name, icon: submenu.menu_icon, routerLink: [submenu.menu_route, submenu.menu_id] });

                    this.commonService.reportList.push({ menuId: submenu.menu_id, menuName: submenu.menu_name });
                  }
                  else {
                    lstSubMenu.push({ name: submenu.menu_name, icon: submenu.menu_icon, routerLink: submenu.menu_route });
                  }
                  this.authorisedMenus.push(submenu.menu_route.replace('/', ''));
                });
              }
              this.dynamicMenu.push({ name: menu.menu_name, icon: menu.menu_icon, routerLink: menu.menu_route, submenu: lstSubMenu });
              if (menu.menu_route != '')
                this.authorisedMenus.push(menu.menu_route.replace('/', ''));
            }
          });
          this.authorisedMenus.push('userdetail');
          this.authorisedMenus.push('transaction');
          this.authorisedMenus.push('create-doa-config');
          this.authorisedMenus.push('create-doa-import');
          this.authorisedMenus.push('create-doa-approval');
          this.authorisedMenus.push('create-doa-rule');
          this.authorisedMenus.push('inactive-user-reallocation');

          let child = this.activeRoute.firstChild;
          if (child ?.snapshot.data) {
            const currentRoute = child.snapshot.data['route'];
            if (currentRoute != '' && this.authorisedMenus.length > 0) {
              if (!this.authorisedMenus.includes(currentRoute)) {
                this.router.navigate(["login"]);
                this.commonService.showMessageBox('Unauthorized access.');
              }
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });

  }

}
